import { apiClient } from '../../config/axios.config';
import { BASE_URL, BASE_PERFORMANCE_URL } from '../apiConfig';

const createPerformance = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-detail`,
    payload,
  );
  return response;
};

const updateKPIComment = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/update-kpi-comment`,
    payload,
  );
  return response;
};

const addWeightage = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-detail-weight`,
    payload,
  );
  return response;
};

const selfRating = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-rating-self`,
    payload,
  );
  return response;
};

const managerRating = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-rating-mgr`,
    payload,
  );
  return response;
};

const fetchPerformance = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/get-performance`,
    payload,
  );
  return response;
};

const performanceHeaderSubmit = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/performance-header-submit`,
    payload,
  );
  return response;
};

const createPerformanceHeader = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-header`,
    payload,
  );
  return response;
};

const deletePerformanceKPI = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/performance-delete`,
    payload,
  );
  return response;
};

const performanceHeaderClose = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/create-performance-header-close`,
    payload,
  );
  return response;
};

const fetchKPIs = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/get-kpis`,
    payload,
  );
  return response;
};

const fetchCalibrationWeightageNDueDate = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/performance-weightage-n-duedate`,
    payload,
  );
  return response;
};

const updateRatingsService = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/update-section-ratings`,
    payload,
  );
  return response;
};

const fetchFiscalYear = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_PERFORMANCE_URL}/get-current-fiscal-year`,
  );
  return response;
};

export {
  createPerformance,
  updateKPIComment,
  addWeightage,
  selfRating,
  managerRating,
  fetchPerformance,
  performanceHeaderSubmit,
  createPerformanceHeader,
  deletePerformanceKPI,
  performanceHeaderClose,
  fetchKPIs,
  fetchCalibrationWeightageNDueDate,
  updateRatingsService,
  fetchFiscalYear,
};
